import(/* webpackMode: "eager", webpackExports: ["RegisterSection"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/myvivaldis/components/blocks/RegisterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/myvivaldis/components/forms/LoginForm.tsx");
;
import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/assets/images/social_share.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/blocks/TranslatedPaths.tsx");
